<template>
  <section class="Search__condition__registration0012">
    <el-row :gutter="0" class="Search__condition__registrationHead">
      <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1">
        <i class="el-icon-close" tabindex="1"></i>
      </router-link>

      <el-col :span="6" class="whiteBg">
        <span class="Search__condition__registrationSpan">検索条件登録</span>
      </el-col>

      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>

      <el-col :span="6"></el-col>
    </el-row>

<!-- Search condition registration Body start-->
    <el-row class="Search__condition__registrationBody">
      <el-form ref="form" :rules="rules" :model="form">
        <el-form-item label="タイトル（必須）" class="title__req" prop="input1" v-if="showtitle == 1">
          <el-input v-model="form.input1" class="title__input"></el-input>
        </el-form-item>
        <el-form-item label="タイトル（必須）" class="title__req" prop="input1" v-else>
          <el-input v-model="form.input1" readonly class="title__input"></el-input>
        </el-form-item>
        <div class="Keyword__search">
          <span class="Keyword__search__conditions">キーワード検索条件</span>

          <el-form-item label="キーワード1" prop="input2">
            <el-input v-model="form.input2"></el-input>
          </el-form-item>

          <el-form-item class="label_less">
            <span class="required__mark">*</span>

            <el-select v-model="form.value1"  @change="handleChange($event)" placeholder class="select__topic">
              <el-option
                v-for="item in getOptionFirst0012"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="キーワード2" prop="input3">
            <el-input v-model="form.input3"></el-input>
          </el-form-item>
        </div>

        <div class="select__or__add">
          <el-form-item>
            <span class="required__mark">*</span>

            <el-select  v-model="form.value2"  @change="handleChange1($event)" placeholder class="news__select">
              <el-option
                v-for="item in getOptionSecond0012"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="Keyword__search2">
          <el-form ref="mediaNameForm" :model="mediaNameForm" label-width="auto" class="DynamicFormInput">
          <el-form-item label="媒体名検索条件">
            <span>※媒体はすべて「OR」検索</span>
          </el-form-item>
      <div v-if="mediaNameForm.items1.length > 0">
          <el-form-item  v-for="(input,k) in mediaNameForm.items1" :key="k">
            <el-form-item :label="input.key"  style="display: flex; width: 100%" class="inner__form"
              :prop="'items1.' + k + '.value'"
              :rules="[{ max: 100, message: '媒体名は100文字以下で入力してください', trigger: 'change'}]">
            <el-row class="add__remove__medium">
              <!-- <span class="dynamicLable">{{ input.key }}</span> -->
              <div class="input__box">
                <el-input type="text" class="form-control" v-model="input.value" prop="value" ></el-input>
              </div>

              <div class="remove__icon">
                <i class="el-icon-remove-outline" @click="remove(k)" v-show="k || ( !k && mediaNameForm.items1.length > 1)"></i>
              </div>

              <div class="add__icon">
                <i class="el-icon-circle-plus-outline" @click="add(k)" v-show="((k == mediaNameForm.items1.length-1) && (mediaNameForm.items1.length !== 5))"></i>
              </div>
            </el-row>
            </el-form-item>
          </el-form-item>
      </div>
      <div v-else-if="this.$route.params.editToken == undefined || this.$route.params.editToken == '' ">
          <el-form-item  v-for="(input,k) in mediaNameForm.items" :key="k" >
            <el-form-item style="display: flex; width: 100%" class="inner__form"
                    :prop="'items.' + k + '.name'"
                    :rules="[{ max: 100, message: '媒体名は100文字以下で入力してください', trigger: 'change'}]">
            <el-row class="add__remove__medium">
              <span class="dynamicLable">{{ input.label }}</span>
              <div class="input__box">
                <el-input type="text" class="form-control" v-model="input.name"></el-input>
              </div>

              <div class="remove__icon">
                <i class="el-icon-remove-outline" @click="removeNew(k)" v-show="k || ( !k && mediaNameForm.items.length > 1)"></i>
              </div>

              <div class="add__icon">
                <i class="el-icon-circle-plus-outline" @click="addNew(k)" v-show="((k == mediaNameForm.items.length-1) && (mediaNameForm.items.length !== 5))"></i>
              </div>
            </el-row>
          </el-form-item>
          </el-form-item>
      </div>
    </el-form>
        </div>
        <el-row class="buttonClearFunction">
          <el-button type="primary" plain @click="open('form')">登録</el-button>

          <el-button type="info"  plain @click="clear_input('form', 'mediaNameForm')">お試し検索</el-button>

         
            <el-button type="info" plain  @click="gotoback('form')">戻る</el-button>
          
        </el-row>
      </el-form>
    </el-row>
  </section>
</template> 

<script>
import router from '../../router';
import { mapGetters } from "vuex";
import Vue from "vue";
import json from '../../components/config.json' 
//import Common from '../../common/CommonFunc.js'
export default {
  name: "Search__condition__registration0012",
  props: [],
  data() {
    return {
      showtitle: '',
      showoperator:'',
      showmediaoperator:'',
      inputs: [
        {
          label:'媒体名1',
          name: ''
        }
      ],
      form: {
        input1: "",
        input2: "",
        input3: "",
        value:[],
        name:'',
        value1: "AND",
        value2: "AND"
      },
      rules: {
        input1: [
          {
            required: true,
            message: "タイトルを入力してください。",
            trigger: "blur"
          },
          { max: 100, message: 'タイトルは100文字以下で入力してください'},
          /***2021/04/20  #10821  START*/
          /***{ pattern:/^[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f\uff00-\uffefa-zA-Z0-9 ]+$/,message:'タイトルは記号以外を入力してください。'}*/
           { pattern:/^[\u2000-\u206f\u2600-\u26ff\u2000-\u206f\u25a0-\u25ff\u3000-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff00-\uffeea-zA-Z0-9]+$/,message:'タイトルは記号以外を入力してください。'}
           /***2021/04/20  #10821  END*/
        ],
        value1: [
          {
            required: true,
            message: "タイトルを入力してください。",
            trigger: "change"
          }
        ],
        input2: [
          { max: 500, message: 'キーワード1には500文字以下で入力してください。',trigger: "change"}
        ],
        input3: [
          { max: 500, message: 'キーワード2には500文字以下で入力してください。',trigger: "change"}
        ]
      },
      mediaNameForm: {
        items: [{
            label:'媒体名1',
            name:''
        }],
        items1:[]
      },
     
      userId:'',
      contractId:'',
      theme_browsing:false,   
      service_linkage_info:[]
    };
  },

  methods: {
    // Method for dynamically add or remove input textbox
    add(index) { 
this.$LogButtonEvent("0012","AddfromEdit");
this.$LogMethodIN("0012","add");                     
        var sam = {};
        var labelindex = index + 2;
        var label = '媒体名' + labelindex;
        sam.key = label;
        // sam.label = label;
        sam.value = ''; 
        this.mediaNameForm.items1.push(sam);
        this.$LogMethodOut("0012","add");
    },
    addNew(index) {
 this.$LogButtonEvent("0012","AddfromNew");
 this.$LogMethodIN("0012","addNew");                   
        var sam = {};
        var labelindex = index + 2;
        var label = '媒体名' + labelindex;
        sam.label = label;
        sam.name = "";
        this.mediaNameForm.items.push(sam);
        this.$LogMethodOut("0012","addNew");
    },
    remove(index) {
  this.$LogButtonEvent("0012","RemovefromEdit");
  this.$LogMethodIN("0012","remove");
      this.mediaNameForm.items1.splice(index, 1);
      var arrremoveEdit =[];
      console.log(this.mediaNameForm.items1);
      for(var i = 0; i < this.mediaNameForm.items1.length;i++){
        var label = '媒体名' + (i+1);
        var sam = {};
        sam.key = label;
        // sam.label = label;
        sam.value = this.mediaNameForm.items1[i].value;
        arrremoveEdit.push(sam);
      }
      this.mediaNameForm.items1 = arrremoveEdit;
      this.$LogMethodOut("0012","remove");
    },
    removeNew(index) {
 this.$LogButtonEvent("0012","RemovefromNew");
 this.$LogMethodIN("0012","removeNew");
      this.mediaNameForm.items.splice(index, 1);
      var arrremove =[];
      for(var i =0; i<this.mediaNameForm.items.length;i++){
        console.log(this.inputs);
        var label = '媒体名' + (i+1)
        console.log(label);
        var sam = {};
        sam.label = label;
        sam.name = this.mediaNameForm.items[i].name;
        arrremove.push(sam);
      }
      this.mediaNameForm.items = arrremove;
      this.$LogMethodOut("0012","removeNew");
    },
    open(form){
 this.$LogButtonEvent("0012","Registration");
 this.$LogMethodIN("0012","open");
      this.$refs[form].validate((valid) => {
        if (valid)
        { 
          var ddArray = [];
          for (var i=0;i < this.mediaNameForm.items.length;i++)
          {
            var ddArray1 = [];
            ddArray1= this.mediaNameForm.items[i].name;
            if(ddArray1 != '')
            {
              ddArray.push(ddArray1);
            }
          }
          var ddArray2 = [];
          for (var j=0;j < this.mediaNameForm.items1.length;j++)
          {
            var ddArray3 = [];
            ddArray3= this.mediaNameForm.items1[j].value;
            if(ddArray3 != '')
            {
              ddArray2.push(ddArray3);
            }
          }
          if(this.showtitle == 1)
          {
            var newRegisteration;
            if(this.input2 != '')
            {
              if(this.input3 != '')
              {
                if(this.name != '')
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword1: this.form.input2,   
                    keyword2: this.form.input3,
                    operator: this.showoperator,
                    media_operator:this.showmediaoperator,
                    process_kbn :1,
                    media_name_list:ddArray
                  }; 
                }
                else
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword1: this.form.input2,   
                    keyword2: this.form.input3,
                    operator: this.showoperator,
                    process_kbn :1,
                    media_operator:this.showmediaoperator
                  }; 
                }
              }
              else
              {
                if(this.name != '')
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword1: this.form.input2,   
                    operator: this.showoperator,
                    media_operator:this.showmediaoperator,
                    process_kbn :1,
                    media_name_list:ddArray
                  };
                }
                else
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword1: this.form.input2,   
                    operator: this.showoperator,
                    process_kbn :1,
                    media_operator:this.showmediaoperator
                  }; 
                }
              }
            }
            else
            {
              if(this.input3 != '')
              {
                if(this.name != '')
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,   
                    keyword2: this.form.input3,
                    operator: this.showoperator,
                    media_operator:this.showmediaoperator,
                    process_kbn :1,
                    media_name_list:ddArray
                  }; 
                }
                else
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword2: this.form.input3,
                    operator: this.showoperator,
                    process_kbn :1,
                    media_operator:this.showmediaoperator
                  }; 
                }
              }
              else
              {
                if(this.name != '')
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1, 
                    operator: this.showoperator,
                    media_operator:this.showmediaoperator,
                    process_kbn :1,
                    media_name_list:ddArray
                  }; 
                }
                else
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1, 
                    operator: this.showoperator,
                    process_kbn :1,
                    media_operator:this.showmediaoperator
                  };
                }
              }
            }
            
            console.log(newRegisteration)
            this.$store.dispatch('sp_Communication0012/registerForm',newRegisteration).then(() => {
              var status = this.getregisterform;
              console.log(status)
              console.log(this.getregisterform);
              if(status == 0)
              {
                this.$alert(this.getregisterformMsgDetails,  json["0012_register_success_title"], {
                  confirmButtonText: 'OK',
                }).then(() => {
                  router.push({name:"sp_0011"});
                })
              }
              else if(this.getmessagecode == "ERR0008")
              {
                this.$alert("入力された検索条件タイトルは既に登録されています。", json["0012_register_failure_title"], {
                    confirmButtonText: 'OK'
                });
              }
              else if(this.getmessagecode == "ERR0011")
              {
                this.$alert("媒体名は100文字以下を入力してください", json["0012_register_failure_title"], {
                    confirmButtonText: 'OK'
                });
              }
              else
              {
                this.$alert(this.getregisterformMsgDetails, json["0012_register_failure_title"], {
                    confirmButtonText: 'OK'
                });
              }
            })
          }
          else
          {
            if(this.input2 != '')
            {
              if(this.input3 != '')
              {
                if(this.value != '')
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword1: this.form.input2,   
                    keyword2: this.form.input3,
                    operator: this.showoperator,
                    media_operator:this.showmediaoperator,
                    process_kbn :2,
                    media_name_list:ddArray2
                  }; 
                }
                else
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword1: this.form.input2,   
                    keyword2: this.form.input3,
                    operator: this.showoperator,
                    process_kbn :2,
                    media_operator:this.showmediaoperator
                  };
                }
              }
              else
              {
                if(this.value != '')
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword1: this.form.input2,   
                    operator: this.showoperator,
                    media_operator:this.showmediaoperator,
                    process_kbn :2,
                    media_name_list:ddArray2	
                  }; 
                }
                else
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword1: this.form.input2,   
                    operator: this.showoperator,
                    process_kbn :2,
                    media_operator:this.showmediaoperator
                  }; 
                }
              }
            }
            else
            {
              if(this.input3 != '')
              {
                if(this.value != '')
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,   
                    keyword2: this.form.input3,
                    operator: this.showoperator,
                    media_operator:this.showmediaoperator,
                    process_kbn :2,
                    media_name_list:ddArray2
                  }; 
                }
                else
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1,
                    keyword2: this.form.input3,
                    operator: this.showoperator,
                    process_kbn :2,
                    media_operator:this.showmediaoperator
                  }; 
                }
              }
              else
              {
                if(this.value != '')
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1, 
                    operator: this.showoperator,
                    media_operator:this.showmediaoperator,
                    process_kbn :2,
                    media_name_list:ddArray2
                  }; 
                }
                else
                {
                  newRegisteration = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    title: this.form.input1, 
                    operator: this.showoperator,
                    process_kbn :2,
                    media_operator:this.showmediaoperator
                  };
                }
                  
              }
            }
            console.log(newRegisteration)
            this.$store.dispatch('sp_Communication0012/registerForm',newRegisteration).then(() => {
              var status = this.getregisterform;
              if(status == 0)
              {
                this.$alert(this.getregisterformMsgDetails,  json["0012_update_success_title"], {
                  confirmButtonText: 'OK',
                }).then(() => {
                  router.push({name:"sp_0011"});
                })
              }
              else if(this.getmessagecode == "ERR0011")
              {
                this.$alert("媒体名は100文字以下を入力してください", json["0012_register_failure_title"], {
                  confirmButtonText: 'OK'
                });
              }
              else
              {
                this.$alert(this.getregisterformMsgDetails, json["0012_update_failure_title"], {
                  confirmButtonText: 'OK'
                });
              }
            })
          }
        }
        else
        {
          // console.log('error submit!!');
          return false;
        }
      });
      this.$LogMethodOut("0012","open");
    },
    // Button click method for input textbox clear
    clear_input (formName, formName1) {
        this.$LogButtonEvent("0012","TrialSearch");
        this.$LogMethodIN("0012","clear_input");
        var ddArray = [];
        if(this.showtitle == 1)
        {
          for (var i=0;i < this.mediaNameForm.items.length;i++)
          {
            var ddArray1 = [];
            ddArray1= this.mediaNameForm.items[i].name;

            if(ddArray1 != ''){
              ddArray.push(ddArray1);
            }
            
          }
        }
        else
        {
          for (var j=0;j < this.mediaNameForm.items1.length;j++)
          {
            var ddArray2 = [];
            ddArray2= this.mediaNameForm.items1[j].value;
            if(ddArray2 != ''){
              ddArray.push(ddArray2);
            }
          }
        }

        var service_linkage_info=this.service_linkage_info;
        var array=[];
        var Service=[];
        if(service_linkage_info != undefined && service_linkage_info != ""){
          for(var g=0; g<service_linkage_info.length; g++){
              array = service_linkage_info[g];
              delete array.csv_output_flag;
              Service.push(array)
          }
        }

        var titleRow = {
          title: this.form.input1,
          keyword1: this.form.input2,   
          keyword2: this.form.input3,
          operator: this.showoperator,
          media_operator:this.showmediaoperator,
          media_name_list:ddArray,
          theme_browsing:this.theme_browsing,
          service_linkage_info: Service
        };
        console.log(titleRow);
        Vue.prototype.$session.set('data', JSON.stringify(titleRow));
        this.$refs[formName].validate((valid) => {
          this.$refs[formName1].validate((valid1) => {
            if (valid)
            {
              if(valid1)
              {
                let routeData = this.$router.resolve({name: 'sp_0013', query: titleRow});
                window.open(routeData.href, '_blank');
              }
            }
          })
        })
        // var t_inputs =  [
        //     {
        //         label:'媒体名1',
        //         name: ''
        //     }
        // ] 
        // this.inputs = t_inputs;
        this.$LogMethodOut("0012","clear_input");
    },
    gotoback(){
 this.$LogButtonEvent("0012","Return");
 this.$LogMethodIN("0012","gotoback");
      var t_inputs =  [
            {
                label:'媒体名1',
                name: ''
            },
        ] 
        this.getnameList = t_inputs;
        router.push({path:"/sp/0011"});
        this.$LogMethodOut("0012","gotoback");
    },
    handleChange($event){
      console.log($event);
      this.showoperator = parseInt($event);
    },
    handleChange1($event){
      console.log($event);
      this.showmediaoperator = parseInt($event);
    }
  },
  computed: {
    ...mapGetters("sp_Situation0012", [
              "getOptionFirst0012",
              "getOptionSecond0012",
              "getsearchTopic0012",
              "gettitle",
              "getkeyword",
              "getoperator",
              "getkeywordTwo",
              "getmediaOperator",
              "getnameList",
              "getfirstIndex",
              "getregisterform",
              "getregisterformMsgDetails",
              "getmessagecode"
    ]),
    ...mapGetters("validationHandler", [
      "getRules",
    ]),
    ...mapGetters("situation0001", [
  
        "getUserId",
        "getContractId",
        "getThemeBrowsing",
        "getServiceLinkageInfo"
    ])
  },
  beforeCreate(){
    //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
    //Common.Session.CheckIsMobile("/sp/0012","/0012"); // MobileScreen Path, WebScreen Path
  },
  //called after all the DOM elements has been mounted
  mounted() {
    //get the user id value from session
    this.userId = this.getUserId

    //get the contract_id value from session
    this.contractId = this.getContractId

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing

    this.service_linkage_info = this.getServiceLinkageInfo
    console.log(this.getnameList)
    console.log(this.$route.params.editToken);
    if(this.$route.params.editToken == undefined || this.$route.params.editToken == "")
    {
      this.showtitle = 1;
      this.showoperator =1;
      this.showmediaoperator = 1;
      this.getnameList =[''];
      console.log("not edit Functionality");
    }
    else
    {
      this.mediaNameForm.items1 = this.getnameList;
      this.showtitle = 0;
      this.form.input1 = this.gettitle;
      this.form.input2 = this.getkeyword;
      this.form.input3 =  this.getkeywordTwo;
      
      if(this.getoperator==1){
            this.form.value1 = 'AND';
            this.showoperator = this.getoperator;
      }else if(this.getoperator==2){
          this.form.value1 = 'OR';
          this.showoperator = this.getoperator;
      }else if(this.getoperator==3){
        this.form.value1 = 'NOT';  
        this.showoperator = this.getoperator;
      } 
      if(this.getmediaOperator==1){
          this.form.value2 = 'AND';
          this.showmediaoperator = this.getmediaOperator;
      }else if(this.getmediaOperator==2){
          this.form.value2 = 'OR';
          this.showmediaoperator = this.getmediaOperator;
      }else if(this.getmediaOperator==3){
          this.form.value2 = 'NOT';
          this.showmediaoperator = this.getmediaOperator;
      }
      console.log(this.getnameList)      
    }
    this.$store.commit('sp_Situation0001/setThemeLoadCheck', 0);
  },
};
</script> 

<style scoped>
@import "0012.css";

@import "../../assets/css/customStyle.css";
</style> 

 